module.exports = __webpack_public_path__ + "media/img/vca/trophy-d3b83cb7eff91eaa0135bc7d761b89bf.png";